import type { BlockPlugin } from "../types";
import { codeBlock } from "./code";
import { fillBlankBlock } from "./fill-blank";
import { flashcardBlock } from "./flashcard";
import { listenTypeBlock } from "./listen-type";
import { matchBlock } from "./match";
import { quizBlock } from "./quiz";
// MEDIA-F2B: video block (completed by watching).
import { videoBlock } from "./video";

export * from "./quiz";
export * from "./flashcard";
export * from "./fill-blank";
export * from "./match";
export * from "./code";
export * from "./listen-type";
export * from "./video";

/** The base block types Space ships with. */
export const baseBlocks: readonly BlockPlugin[] = [
  quizBlock,
  flashcardBlock,
  fillBlankBlock,
  matchBlock,
  codeBlock,
  listenTypeBlock,
  // MEDIA-F2B
  videoBlock,
] as BlockPlugin[];
